import http from "./httpClient.js";

export async function saveSubscription(data, payloadToken, schoolId) {
    const response = await http.post(`/school/${schoolId}/subscription`, data, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return response.data;
}

export async function loadSubscriptions(payloadToken, schoolId) {
    const response = await http.get(`/school/${schoolId}/subscription`, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        },
        params: {
            sort: '-createAt',
        }
    });
    return response.data;
}

export async function renewSubscription(data, payloadToken, schoolId) {
    const idSubscription = data.subscriptionId;
    const response = await http.post(`/school/${schoolId}/subscription/${idSubscription}/renewal`, data, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return response.data;
}

export async function getUserSubscriptions(userId, payloadToken) {
    const response = await http.get(`/users/${userId}/subscriptions`, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return response.data;
}

export async function requestFreezeService(userId, subId, description, payloadToken) {
    const response = await http.post(
        `/users/${userId}/subscription/${subId}/freeze-request`,
        { description },
        { headers: { Authorization: `Bearer ${payloadToken}` } }
    );
    return response.data;
}

export async function resolveFreezeRequestService(schoolId, subId, requestId, action, payloadToken) {
    const response = await http.patch(
        `/school/${schoolId}/subscription/${subId}/freeze-request/${requestId}`,
        { action },
        { headers: { Authorization: `Bearer ${payloadToken}` } }
    );
    return response.data;
}

export async function activateSubscriptionService(data, payloadToken, schoolId) {
    const idSubscription = data.subscriptionId; 
    const patchBody = { 
        status: data.status
     }; 

    const response = await http.patch(
        `/school/${schoolId}/subscription/${idSubscription}/status`,
        patchBody,
        {
            headers: {
                Authorization: `Bearer ${payloadToken}`
            }
        }
    );
    
    return response.data;
}
